export default __webpack_public_path__ + "static/client0-ca68b0954754636311a21f580d024c5d.png";